import styled from 'styled-components';
import { Image as AntdImage } from 'antd';
// Antd uses this under the hood
import { ImageProps as AntdImageProps } from 'rc-image';

export type ImageProps = AntdImageProps;
export const Image = styled(AntdImage)``;
export default Image;
